import React from "react"
import Seo from "../components/seo"
import NavigationBar from "../components/NavigationBar"
import ContactBox from "../components/ContactBox"
import Footer from "../components/Footer"
import CookiesModal from "../components/CookiesModal"
import RichText from "../components/RichText"
import { Link, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import "./BlogTemplate.scss"

const BlogTemplate = ({ data }) => {
  const { title, date, cover, description, content, author: defaultAuthor } = data.contentfulBlog
  const author = defaultAuthor || { name: 'Derevo', title: 'Team' }

  return (
    <>
      <NavigationBar activePage="blog" />
      <section id="article">
        <div className="content">
          <div className="navigationbar-space">
            <Link to="/blog">
              <span className="back-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="14.25" height="22.828" viewBox="0 0 14.25 22.828">
                  <path d="M17501.492-284.62l-10,9.883,10,10.117" transform="translate(-17488.664 286.042)" />
                </svg>
                <span>Regresar a Blog</span>
              </span>
            </Link>
          </div>
          <div>
            <div className="text">
              <div className="header">
                <h1 className="title">{title}</h1>
                <div className="author">
                  <div className="avatar">
                    {
                      author.photo ?
                        <GatsbyImage image={getImage(author.photo.localFile)} alt={author.name} />
                        : (
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20">
                            <g transform="translate(-157.996 -604.5)">
                              <g transform="translate(160.5 604.5)">
                                <circle cx="5.5" cy="5.5" r="5.5" />
                                <circle cx="5.5" cy="5.5" r="4.7" />
                              </g>
                              <g transform="translate(157.996 616.5)">
                                <path d="M8,0c4.418,0,8,2.533,8,5.657s-16,3.124-16,0S3.582,0,8,0Z" />
                                <path d="M 8 1.600004196166992 C 6.217280387878418 1.600004196166992 4.492130279541016 2.096884250640869 3.266909599304199 2.963254451751709 C 2.689358711242676 3.37164306640625 1.748748779296875 4.206087589263916 1.615816116333008 5.377068519592285 C 1.841009140014648 5.518145561218262 2.39323616027832 5.785536766052246 3.593040466308594 6.022274494171143 C 4.827520370483398 6.265854358673096 6.392609596252441 6.399994373321533 8 6.399994373321533 C 9.607389450073242 6.399994373321533 11.1724796295166 6.265854358673096 12.40695953369141 6.022274494171143 C 13.60676383972168 5.785536766052246 14.15899085998535 5.518145561218262 14.38418388366699 5.377068519592285 C 14.25125122070312 4.206087589263916 13.31064224243164 3.37164306640625 12.73308944702148 2.963254451751709 C 11.50786972045898 2.096884250640869 9.782720565795898 1.600004196166992 8 1.600004196166992 M 8 4.76837158203125e-06 C 12.41827964782715 4.76837158203125e-06 16 2.53266429901123 16 5.656854629516602 C 16 8.781044006347656 0 8.781044006347656 0 5.656854629516602 C 0 2.53266429901123 3.581720352172852 4.76837158203125e-06 8 4.76837158203125e-06 Z" />
                              </g>
                            </g>
                          </svg>
                        )
                    }
                  </div>
                  <div className="info">
                    <div>
                      <span>{date}</span>
                    </div>
                    <div>
                      <span>{author.name} </span>
                      <span>{author.title}</span>
                    </div>
                  </div>
                </div>
                <p className="description">{description.description}</p>
                <div className="image">
                  <GatsbyImage image={getImage(cover.localFile)} alt={cover.description}/>
                </div>
              </div>
              <div className="article">
                <RichText content={content}/>
              </div>
              <div className="tags">
                <span>{date} - </span><span>{author.name}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ContactBox />
      <Footer />
      <CookiesModal />
    </>
  )
}

export default BlogTemplate

export const Head = ({ data, location }) => {
  const { title, description, cover } = data.contentfulBlog
  const { pathname } = location

  return <Seo title={title} description={description.description} pathname={pathname} image={cover.localFile.publicURL} />
}

export const query = graphql`
  query BlogTemplateQuery($pagePath: String) {
    contentfulBlog(slug: {eq: $pagePath}) {
      slug
      title
      date(formatString: "yyyy/MM/DD")
      cover {
        description
        localFile {
          publicURL
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      description {
        description
      }
      content {
        raw
        references {
          ... on ContentfulAsset {
            contentful_id
            title
            description
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
            __typename
          }
        }
      }
      author {
        name
        title
        photo {
          localFile {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  }
`